var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExploring(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "#2B2A29"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.9995C18 23.9995 24 17.9995 24 11.9995C24 17.9995 30 23.9995 36 23.9995C30 23.9995 24 29.9995 24 35.9995C24 29.9995 18 23.9995 12 23.9995ZM10.6666 33.9995C11.7773 33.9995 14 31.7768 14 30.6661C14 31.7768 16.2226 33.9995 17.3333 33.9995C16.2226 33.9995 14 36.2221 14 37.3328C14 36.2221 11.7773 33.9995 10.6666 33.9995ZM29.3333 14.6661C30.6666 14.6661 33.3333 11.9995 33.3333 10.6661C33.3333 11.9995 36 14.6661 37.3333 14.6661C36 14.6661 33.3333 17.3328 33.3333 18.6661C33.3333 17.3328 30.6666 14.6661 29.3333 14.6661Z",
    stroke: "#FFED00",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploring);
export default __webpack_public_path__ + "static/media/exploring.909d220d940c8fd33dabb3020f9482c1.svg";
export { ForwardRef as ReactComponent };